import { api } from "@/api";
import type { IAMLFormData } from "./types";

export const submitAML = (data: IAMLFormData) =>
  api.post<string>(`/anti-money-launderings/form`, data).then((r) => r.data);
